import { Box, Text, Input } from "@chakra-ui/react";
import ModalLayout from "../Layout/ModalLayout";

const CustomFilterModal = ({ open, setOpen, setFilters, filters }) => {
  return (
    <>
      <ModalLayout
        setIsOpen={setOpen}
        backHandler={() => setOpen(!open)}
        isOpen={open}
        title="Custom Date Filter"
        loading={false}
        rejectHandler={() => {
          setOpen(!open);
        }}
      >
        <Box mt="20px" w="100%">
          <Text fontWeight="500" fontSize="13px" color="#33343D">
            From Date
          </Text>
          <Input
            value={filters.from}
            onChange={(e) => {
              setFilters({ ...filters, from: e.currentTarget.value });
            }}
            type="date"
            mt="10px"
            className="form-input"
            placeholder="Enter Start Date"
          />
        </Box>

        <Box mt="20px" w="100%">
          <Text fontWeight="500" fontSize="13px" color="#33343D">
            To Date
          </Text>
          <Input
            value={filters.to}
            onChange={(e) => {
              setFilters({ ...filters, to: e.currentTarget.value });
            }}
            type="date"
            mt="10px"
            className="form-input"
            placeholder="Enter End Date"
          />
        </Box>
      </ModalLayout>
    </>
  );
};

export default CustomFilterModal;
